"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["title"];

function SvgTimeAndDate(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    $_css: props.color,
    $_css2: props.size,
    $_css3: props.size,
    $_css4: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.462 13.162V5.85h13.163V3.656c0-.806-.656-1.462-1.463-1.462h-.73V0h-1.463v3.656h-.731V2.194h-5.12V0H3.657v3.656h-.731V2.194H1.463C.655 2.194 0 2.85 0 3.656v9.506c0 .807.656 1.463 1.462 1.463H5.85v-1.463H1.463zM12.939 18a5.068 5.068 0 01-5.063-5.063 5.068 5.068 0 015.063-5.062A5.068 5.068 0 0118 12.938 5.068 5.068 0 0112.937 18zm0-8.679a3.62 3.62 0 00-3.617 3.617 3.62 3.62 0 003.617 3.616 3.62 3.62 0 003.616-3.616 3.62 3.62 0 00-3.616-3.617zM15.75 13.5h-3.375v-3.375h1.688v2.025h1.687v1.35z",
    fill: "currentColor"
  }));
}

var _default = SvgTimeAndDate;
exports["default"] = _default;

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "TimeAndDate___StyledSvg",
  componentId: "sc-1ccnj5q-0"
})(["color:", ";width:", ";height:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});
//# sourceMappingURL=TimeAndDate.js.map